<template>
  <div
    class="container"
    :style="{width: openType === 'wechat' ? 'calc(100% - env(safe-area-inset-left) - env(safe-area-inset-right))' : '100%'}"
  >
    <div class="header">
      <div @click="handleBack" class="back"></div>
      <div class="title">本局回顾</div>
      <div class="logo"></div>
    </div>
    <div class="review">
      <div class="left">
        <div class="user">
          <div class="score">
            <span>{{records[currentIndex] ? records[currentIndex].user_win_score : '0'}}</span>
            <img src="https://image.co-study.com.cn/web/answer-game/fen.png" />
          </div>
          <div style="display:flex;">
            <div
              style="display:flex;flex-direction:column;justify-content:space-evenly;align-items:flex-end;"
            >
              <div class="energy">
                <img src="https://image.co-study.com.cn/web/answer-game/energy-icon.png" />
                <span>{{homeownerInfo.power_count}}</span>
              </div>
              <div class="name" style="text-align:right">{{homeownerInfo.nickname}}</div>
            </div>
            <div class="avatar">
              <img
                :src="homeownerInfo.avatar ? homeownerInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="user">
          <div class="score">
            <span>{{records[currentIndex] ? records[currentIndex].opponent_win_score : '0'}}</span>
            <img src="https://image.co-study.com.cn/web/answer-game/fen.png" />
          </div>
          <div style="display:flex;">
            <div class="avatar">
              <img
                :src="opponentInfo.avatar ? opponentInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
            <div style="display:flex;flex-direction:column;justify-content:space-evenly">
              <div class="energy">
                <img src="https://image.co-study.com.cn/web/answer-game/energy-icon.png" />
                <span>{{opponentInfo.power_count}}</span>
              </div>
              <div class="name">{{opponentInfo.nickname}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="lightning-left">
          <img src="https://image.co-study.com.cn/web/answer-game/lightning-left.png" />
        </div>
        <div class="lightning-right">
          <img src="https://image.co-study.com.cn/web/answer-game/lightning-right.png" />
        </div>
        <div class="tips">
          <span>第{{chineseNumber[currentIndex]}}题</span>
          <span>（共5题）最后一题双倍得分</span>
        </div>
        <div
          class="subject"
        >{{records[currentIndex].context === 2? '_____________，' : ''}}{{records[currentIndex].poetry_text}}{{records[currentIndex].context === 1? '，_____________' : ''}}</div>
        <div class="answer">
          <div
            class="answer-item"
            :class="records[currentIndex].user_answer_index === 0 || records[currentIndex].opponent_answer_index === 0?'answer-active':''"
            :style="{color: (records[currentIndex].user_answer_index === 0 || records[currentIndex].opponent_answer_index === 0) ? records[currentIndex].right_answer_index === 0?'#7C9EEB':'#C54D46':''}"
          >
            <span class="answer-serial">A</span>
            <span class="answer-content">{{records[currentIndex].choice_poetry_text_1}}</span>
            <div
              v-if="records[currentIndex].user_answer_index === 0 || records[currentIndex].opponent_answer_index === 0"
              class="result"
            >
              <img
                :src="records[currentIndex].right_answer_index === 0 ? 'https://image.co-study.com.cn/web/answer-game/correct.png' : 'https://image.co-study.com.cn/web/answer-game/wrong.png'"
              />
            </div>
            <div class="answer-avatar">
              <img
                v-if="records[currentIndex].user_answer_index === 0"
                :src="homeownerInfo.avatar ? homeownerInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
              <img
                v-if="records[currentIndex].opponent_answer_index === 0"
                :src="opponentInfo.avatar ? opponentInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
          </div>
          <div
            class="answer-item"
            :class="records[currentIndex].user_answer_index === 1 || records[currentIndex].opponent_answer_index === 1?'answer-active':''"
            :style="{color: (records[currentIndex].user_answer_index === 1 || records[currentIndex].opponent_answer_index === 1) ? records[currentIndex].right_answer_index === 1?'#7C9EEB':'#C54D46':''}"
          >
            <span class="answer-serial">B</span>
            <span class="answer-content">{{records[currentIndex].choice_poetry_text_2}}</span>
            <div
              v-if="records[currentIndex].user_answer_index === 1 || records[currentIndex].opponent_answer_index === 1"
              class="result"
            >
              <img
                :src="records[currentIndex].right_answer_index === 1 ? 'https://image.co-study.com.cn/web/answer-game/correct.png' : 'https://image.co-study.com.cn/web/answer-game/wrong.png'"
              />
            </div>
            <div class="answer-avatar">
              <img
                v-if="records[currentIndex].user_answer_index === 1"
                :src="homeownerInfo.avatar ? homeownerInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
              <img
                v-if="records[currentIndex].opponent_answer_index === 1"
                :src="opponentInfo.avatar ? opponentInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
          </div>
          <div
            class="answer-item"
            :class="records[currentIndex].user_answer_index === 2 || records[currentIndex].opponent_answer_index === 2?'answer-active':''"
            :style="{color: (records[currentIndex].user_answer_index === 2 || records[currentIndex].opponent_answer_index === 2) ? records[currentIndex].right_answer_index === 2?'#7C9EEB':'#C54D46':''}"
          >
            <span class="answer-serial">C</span>
            <span class="answer-content">{{records[currentIndex].choice_poetry_text_3}}</span>
            <div
              v-if="records[currentIndex].user_answer_index === 2 || records[currentIndex].opponent_answer_index === 2"
              class="result"
            >
              <img
                :src="records[currentIndex].right_answer_index === 2 ? 'https://image.co-study.com.cn/web/answer-game/correct.png' : 'https://image.co-study.com.cn/web/answer-game/wrong.png'"
              />
            </div>
            <div class="answer-avatar">
              <img
                v-if="records[currentIndex].user_answer_index === 2"
                :src="homeownerInfo.avatar ? homeownerInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
              <img
                v-if="records[currentIndex].opponent_answer_index === 2"
                :src="opponentInfo.avatar ? opponentInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
          </div>
          <div
            class="answer-item"
            :class="records[currentIndex].user_answer_index === 3 || records[currentIndex].opponent_answer_index === 3?'answer-active':''"
            :style="{color: (records[currentIndex].user_answer_index === 3 || records[currentIndex].opponent_answer_index === 3) ? records[currentIndex].right_answer_index === 3?'#7C9EEB':'#C54D46':''}"
          >
            <span class="answer-serial">D</span>
            <span class="answer-content">{{records[currentIndex].choice_poetry_text_4}}</span>
            <div
              v-if="records[currentIndex].user_answer_index === 3 || records[currentIndex].opponent_answer_index === 3"
              class="result"
            >
              <img
                :src="records[currentIndex].right_answer_index === 3 ? 'https://image.co-study.com.cn/web/answer-game/correct.png' : 'https://image.co-study.com.cn/web/answer-game/wrong.png'"
              />
            </div>
            <div class="answer-avatar">
              <img
                v-if="records[currentIndex].user_answer_index === 3"
                :src="homeownerInfo.avatar ? homeownerInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
              <img
                v-if="records[currentIndex].opponent_answer_index === 3"
                :src="opponentInfo.avatar ? opponentInfo.avatar : 'https://image.co-study.com.cn/web/answer-game/default-avatar.png'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <div class="btn-top">
        <div @click="previous" class="btn" :class="currentIndex === 0 ? 'no-more' : ''">上一题</div>
        <div @click="next" class="btn" :class="currentIndex === maxIndex ? 'no-more' : ''">下一题</div>
      </div>
      <div class="btn-bottom">
        <div @click="answerDetail" class="btn">答案解析</div>
        <div @click="gameAgain" class="btn">再来一局</div>
        <div v-if="openType === 'app' && isWin" @click="showOff" class="btn">炫耀一下</div>
      </div>
    </div>

    <question v-if="questionPopup" @close="questionPopup = false" :detail="detail" type="review"></question>
  </div>
</template>

<script>
import Question from '../components/popup/question'
import Model from '../model'
import Websocket from '../util/websocket.js'
import { mapGetters } from 'vuex'
import Utils from '../util/util'
import Config from '../config'

export default {
  components: {
    Question
  },
  data() {
    return {
      questionPopup: false,   // 问题详情弹窗
      questionNumber: '',
      records: [],
      currentIndex: 0,    // 当前问题序号
      maxIndex: 0,
      homeownerInfo: {},
      opponentInfo: {},
      chineseNumber: ['一', '二', '三', '四', '五'],
      detail: {},
      openType: '',
      isHomeowner: false,
      isWin: false,
      isKickOut: false   // 是否已被踢出
    }
  },
  computed: {
    ...mapGetters(['webData', 'userinfo'])
  },
  watch: {
    async webData(data) {
      const status = data.cmd
      if (status === 'room_leave') {
        if (data.state_code === 0) {
          this.$toast({ message: '对手已经离开了~', className: 'toast-trans' })
        }
        if (data.state_code === 9) {
          this.isKickOut = true
        }
      }
    }
  },
  async created() {
    this.openType = Utils.getOpenType()
    this.questionNumber = this.$route.query.questionNumber
    this.isWin = this.$route.query.isWin
    await this.getGameReview()
  },
  methods: {
    // 答题详情
    async answerDetail() {
      const res = await Model.getPoetryDetail({
        poetry_id: this.records[this.currentIndex].poetry_id
      })
      this.detail = res.data
      this.questionPopup = true
    },
    // 获取答题结果
    async getGameReview() {
      const res = await Model.getGameReview({
        question_number: this.questionNumber
      })
      const data = res.data
      this.records = data.records
      if (this.userinfo.id == data.records[0].user_id) {
        this.isHomeowner = true
        this.homeownerInfo = data.user_info
        this.opponentInfo = data.opponent_info
      } else {
        this.opponentInfo = data.user_info
        this.homeownerInfo = data.opponent_info
      }
      this.maxIndex = data.records.length - 1
    },
    // 再来一局，此时需要先判断是否已超时被踢出，被踢出则发送room_leave提到首页
    gameAgain() {
      if (this.isKickOut) {
        Websocket.websocketsend(JSON.stringify({
          "cmd": "room_leave"
        }))
        this.$store.commit('setRoomId', '')
        this.$toast({ message: '你错过这次对战机会啦，可以自己去邀请别人哦！', className: 'toast-trans' })
        this.$router.replace('/index')
      } else {
        Websocket.websocketsend(JSON.stringify({
          "cmd": "game_again"
        }))
        if (this.pkType === 'invite') {
          this.$router.replace('/waiting')
        } else {
          this.$router.replace('/waitingMatch')
        }
      }
    },
    // 上一题
    previous() {
      if (this.currentIndex === 0) {
        return
      }
      this.currentIndex--
    },
    // 下一题
    next() {
      if (this.currentIndex === this.maxIndex) {
        return
      }
      this.currentIndex++
    },
    // 返回
    handleBack() {
      Websocket.websocketsend(JSON.stringify({
        "cmd": "room_leave"
      }))
      this.$store.commit('setRoomId', '')
      this.$router.replace('index')
    },

    showOff() {
      let results
      if (this.isHomeowner) {
        results = this.records[this.records.length - 1].user_win_score
      } else {
        results = this.records[this.records.length - 1].opponent_win_score
      }
      const isIosOrAndroid = Utils.isIosOrAndroid()
      const params = {
        url: `${Config.baseURL}`,
        results
      }
      if (isIosOrAndroid === 'android') {
        try {
          window.Android.shareResults(JSON.stringify(params))
        } catch (e) {
          this.$toast({ message: '调用失败', className: 'toast-trans' })
        }
      } else if (isIosOrAndroid === 'ios') {
        try {
          window.webkit.messageHandlers.shareResults.postMessage(JSON.stringify(params))
        } catch (e) {
          this.$toast({ message: '调用失败', className: 'toast-trans' })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  $rem: 375px;
  @return ($px/$rem) + rem;
}

.container {
  .btn-wrap {
    height: px2rem(250px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: px2rem(13px);
    position: absolute;
    right: px2rem(48px);
    top: px2rem(94px);
    color: #534831;

    .btn-top {
      .btn {
        margin-bottom: px2rem(16px);
        background: url("https://image.co-study.com.cn/web/answer-game/navi-bg-s.png");
        background-size: 100% 100%;
      }

      .no-more {
        opacity: 0.5;
        filter: alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
      }
    }

    .btn-bottom {
      .btn {
        margin-top: px2rem(16px);
        color: #534831;
        background: url("https://image.co-study.com.cn/web/answer-game/review-btn-bg.png");
        background-size: 100% 100%;
      }

      .btn:nth-child(1) {
        color: #965e31;
      }
    }

    .btn {
      width: px2rem(70px);
      height: px2rem(20px);
      line-height: px2rem(20px);
      text-align: center;
      background: url("https://image.co-study.com.cn/web/answer-game/navi-bg-s.png");
      background-size: 100% 100%;
      font-weight: 600;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0 px2rem(18px) 0 px2rem(32px);

    .back {
      width: px2rem(21px);
      height: px2rem(30px);
      background: url("https://image.co-study.com.cn/web/answer-game/back.png");
      background-size: 100% 100%;
    }

    .title {
      width: px2rem(100px);
      height: px2rem(42px);
      line-height: px2rem(42px);
      background: url("https://image.co-study.com.cn/web/answer-game/title-bg.png");
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: px2rem(16px);
      color: #ede4d1;
      text-align: center;
    }

    .logo {
      width: px2rem(72px);
      height: px2rem(46px);
      background: url("https://image.co-study.com.cn/web/answer-game/logo.png");
      background-size: 100% 100%;
    }
  }

  .review {
    width: px2rem(525px);
    height: px2rem(254px);
    background: rgba(0, 0, 0, 0.1);
    position: absolute;
    overflow: hidden;
    margin-top: px2rem(30px);

    .left,
    .right {
      width: 32%;
      height: px2rem(62px);
      background: url("https://image.co-study.com.cn/web/answer-game/pk-user-bg.png")
        center;
      background-size: 100% 100%;

      .user {
        display: flex;
        flex-direction: column;
        align-items: center;

        .score {
          display: flex;
          align-items: flex-end;

          span {
            font-size: px2rem(42px);
            text-shadow: #fff 2px 2px 0, #fff -2px -2px 0, #fff -2px 2px 0,
              #fff 2px -2px 0, #fff 2px 0 0, #fff -2px 0 0, #fff 0 2px 0,
              #fff 0 -2px 0;
            color: #965e31;
          }

          img {
            width: px2rem(18px);
            height: px2rem(18px);
            position: relative;
            top: px2rem(-4px);
            right: px2rem(-2px);
          }
        }

        .energy {
          display: flex;
          align-items: center;

          span {
            font-size: px2rem(10px);
            color: #534831;
            font-weight: 600;
          }

          img {
            width: px2rem(8px);
            height: px2rem(11px);
          }
        }

        .name {
          width: px2rem(66px);
          font-size: px2rem(10px);
          color: #534831;
          font-weight: 600;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          height: px2rem(16px);
          line-height: px2rem(16px);
        }

        .avatar {
          width: px2rem(35px);
          height: px2rem(35px);
          border-radius: 50%;
          border: 1px solid #bea577;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .left {
      position: absolute;
      left: -9%;
      top: 40%;
      // transform: translateY(-50%);

      .user {
        position: absolute;
        top: px2rem(-22px);
        right: px2rem(8px);

        .avatar {
          margin-left: px2rem(2px);
        }
      }
    }

    .right {
      position: absolute;
      right: -9%;
      top: 40%;
      // transform: translateY(-50%);

      .user {
        position: absolute;
        top: px2rem(-22px);
        left: px2rem(8px);

        .avatar {
          margin-right: px2rem(2px);
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      width: 55%;

      .lightning-left,
      .lightning-right {
        width: 13%;
        height: 0;
        padding-bottom: 12%;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .lightning-left {
        position: absolute;
        left: 0;
        top: px2rem(52px);
      }

      .lightning-right {
        position: absolute;
        right: 0;
        top: px2rem(52px);
      }

      .tips {
        width: 66%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        color: #fff;
        font-size: px2rem(13px);
        margin-top: px2rem(6px);

        span:nth-child(2) {
          font-size: px2rem(10px);
          transform: scale(0.8, 0.8);
          letter-spacing: px2rem(1px);
          margin-right: px2rem(-20px);
        }
      }

      .subject {
        width: 76%;
        height: px2rem(52px);
        background: url("https://image.co-study.com.cn/web/answer-game/subject-bg.png");
        background-size: 100% 100%;
        font-size: px2rem(10px);
        color: #534831;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: px2rem(18px);
        padding: 0 9%;
        box-sizing: border-box;
        margin-bottom: px2rem(6px);
      }

      .answer {
        width: 60%;

        .answer-active {
          background: url("https://image.co-study.com.cn/web/answer-game/answer-white-bg.png") !important;
          background-size: 100% 100% !important;
        }

        .answer-item {
          width: 100%;
          height: px2rem(32px);
          background: url("https://image.co-study.com.cn/web/answer-game/pk-user-bg.png");
          background-size: 100% 100%;
          margin-bottom: px2rem(5px);
          display: flex;
          align-items: center;
          padding: 0 px2rem(16px);
          box-sizing: border-box;
          position: relative;

          .answer-serial {
            font-size: px2rem(21px);
            margin-right: px2rem(6px);
          }

          .answer-content {
            font-size: px2rem(10px);
            line-height: px2rem(13px);
          }

          .result {
            width: px2rem(28px);
            height: px2rem(28px);
            position: absolute;
            right: px2rem(-15px);

            img {
              width: 100%;
              height: 100%;
            }
          }

          .answer-avatar {
            width: px2rem(50px);
            display: flex;
            position: absolute;
            right: px2rem(-62px);

            img {
              width: px2rem(18px);
              height: px2rem(18px);
              border-radius: 50%;
              background: #fff;
            }

            img:nth-child(2) {
              margin-left: px2rem(3px);
            }
          }
        }
      }
    }
  }
}
</style>